export default {
  TITLE_LOGIN: 'Erriff Health - Login',
  TITLE_REGISTER: 'Erriff Health - Register',
  TITLE_WELCOME: 'Erriff Health - Welcome',
  TITLE_PROVIDER: 'Erriff Health - Provider',
  TITLE_PROVIDERS: 'Erriff Health - Providers',
  TITLE_PROCEDURES: 'Erriff Health - Procedures',
  TITLE_LABS: 'Erriff Health - Labs',
  TITLE_DIAGNOSIS: 'Erriff Health - Diagnosis',
  TITLE_MEDICATION: 'Erriff Health - Medication',
  TITLE_VACCINATION: 'Erriff Health - Vaccination',
  TITLE_CDA: 'Erriff Health - CDAs',
  TITLE_REPORT: 'Erriff Health - Report',
  TITLE_REPORTS: 'Erriff Health - Reports',
  TITLE_PDF: 'Erriff Health - PDFs',
  TITLE_DOCUMENTS: 'Erriff Health - Documents', 
  TITLE_WATCH: 'Erriff Health - Graph your health condition',
  TITLE_VITALS: 'Erriff Health - Graph your vitals',
  TITLE_PROFILE: 'Erriff Health - Profile',
  TITLE_CHANGE_PASSWORD: 'Erriff Health - Change Password',
  TITLE_CONTACT: 'Erriff Health - Contact',
  TITLE_404: 'Erriff Health - Page Not Found',
  TITLE_SEARCH: 'Erriff Health - Search',
  TITLE_ALLERGY: 'Erriff Health - Allergy',
  TITLE_FORGOT: 'Erriff Health - Forgot Password',
  TITLE_RESET: 'Erriff Health - Reset Password',
  TITLE_VERIFY: 'Erriff Health - Verify Your Account',
  TITLE_DIRECTIVES: 'Erriff Health - Directives',
  TITLE_DEVICES: 'Erriff Health - Devices',
  TITLE_NOTES: 'Erriff Health - Notes',
  DATA_UPLOAD: 'Erriff Health - Data Upload',
  TITLE_CURRENT_PROC: 'Erriff Health - Current Procedures',
  TITLE_CURRENT_DIAG: 'Erriff Health - Current Diagnosis',
  TITLE_CURRENT_MED: 'Erriff Health - Current Medications',
  TITLE_CURRENT_PROV: 'Erriff Health - Current Providers',
  TITLE_CURRENT_NURSE: 'Erriff Health - Account Nurses',
  TITLE_PATIENT_NURSE: 'Erriff Health - Patient Nurses',
  TITLE_MY_ORG:'Erriff Health - Users and Status',
  TITLE_ORDERS: 'Erriff Health - Orders',
  TITLE_MED_ADMIN: 'Erriff Health - Medication Administration',
  TITLE_CPT_BILLING: 'Erriff Health - CPT Billing',
  TITLE_CPT_PAGE: 'Erriff Health - CPT Codes',
  TITLE_VERIFY_NURSE: 'Erriff Health - Verify Nurse',
  TITLE_VERIFY_ACCOUNT: 'Erriff Health - Verify Account',
  TITLE_VERIFY_PROVIDER: 'Erriff Health - Provider Registration', // /verifyProvider invite page
  TITLE_PRIVACY_POLICY: 'Erriff Health - Privacy Policy',
  TITLE_TERMS_CONDITIONS: 'Erriff Health - Terms & Conditions',
  TITLE_INFORMATION_PROTECTION: 'Erriff Health - Information Protection',
  TITLE_PATIENT_CARDS: 'Erriff Health - Patients',
  TITLE_GROUPS: 'Erriff Health - Groups',
  TITLE_ALLIEDPROFS: 'Erriff Health - Allied Professional Cards',
  TITLE_HOME_HEALTH_AIDE: 'Erriff Health - Home Health Aides',
  TITLE_SCHEDULING: 'Erriff Health - Provider Scheduling',
  TITLE_ONBOARDING: 'Erriff Health - Nurse Onboarding'
}
